const features_and_bugs_tour = {
	features_bugs_tour_steps: {
		bug_button: {
			description:
				"Haben Sie einen Fehler gefunden? Teilen Sie uns dies über diese Schaltfläche mit.",
			title: "Haben Sie einen Fehler gefunden?",
		},
		bug_text: {
			description: "Hier können Sie Fehler sehen, die andere gefunden haben.",
			title: "Text melden",
		},
		features_button: {
			description: "Hier können Sie Ihre eigene Funktionsanfrage stellen.",
			title: "Ihre eigene Anfrage?",
		},
		features_text: {
			description: "Dies sind Anfragen zur Verbesserung unserer Website.",
			title: "Gewünschte Funktionen",
		},
	},

	features_dialog_tour_steps: {
		description_bug: {
			description:
				"Hier können Sie eine Beschreibung schreiben, um uns mitzuteilen, was Sie möchten.",
			title: "Geben Sie uns eine Beschreibung",
		},
		title_bug: {
			description: "Hier können Sie den Titel Ihrer Anfrage schreiben.",
			title: "Titel",
		},
		upload_bug: {
			description:
				"Hier können Sie einen Screenshot hochladen. Klicken Sie in die Mitte und wählen Sie die Datei aus, die Sie hochladen möchten.",
			title: "Hochladen",
		},
	},
};
export default features_and_bugs_tour;
